import { Endpoint } from '@App/app/entities/auth/endpoint.model';
import { UserPermissions } from '@App/app/entities/auth/permissions.enum';
import { CompanySelectionService } from '@App/app/shared/services/company-selection/company-selection.service';
import { Directive, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Directive()
export abstract class BaseCompanySelectionDirective implements OnInit {
  endpoints: Endpoint[];
  buttonAppears = true;
  searchText: string;
  permissions = UserPermissions;

  constructor(
    protected route: ActivatedRoute,
    protected companySelectionService: CompanySelectionService,
  ) {}

  ngOnInit(): void {
    this.companySelectionService.loadEndpoints((endpoints) => {
      this.endpoints = endpoints;
    });
    this.companySelectionService.checkFreshLogin(this.route, () => {
      this.buttonAppears = false;
    });
  }

  onClick(endpoint: Endpoint) {
    this.companySelectionService.onClick(endpoint);
  }

  onAdminPanelClick() {
    this.companySelectionService.onAdminPanelClick();
  }
}
